import useSettingsGlobals from '@/composables/useSettingsGlobals';

const { $WEB_VIEW, $PLATFORM } = useSettingsGlobals();  

export const useGoToAppStore = (primaryActivity) => {
  const appIds = {
    android: {
      kite: 'com.windalert.android.ikitesurf',
      windsurf: 'com.windalert.android.iwindsurf',
      sail: 'com.windalert.android.sailflow',
      fish: 'com.windalert.android.fishweather'
    },
    ios: {
      kite: '555643284',
      windsurf: '564865754',
      sail: '555309964',
      fish: '555644333'
    }
  }

  const appId = appIds[$PLATFORM][primaryActivity]

  if ($WEB_VIEW) {
    if ($PLATFORM == 'android') {
      if (appId != undefined && appId != null) {
        alert('gotoapp,' + appId)
      }
    } else {
      if (appId != undefined && appId != null) {
        var info = {
          type: 'go-to-app',
          appId: appId
        }
        window.webkit.messageHandlers.observe.postMessage(info)
      }
    }
  }
}
